import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Logger } from 'vas-mobile-api';

import { DataExchangeService } from './dataexchange.service';

@Injectable()
export class SecretService implements CanActivate {

    private logger: Logger;

    constructor(
        private router: Router,
        private des: DataExchangeService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        if (this.des.isSecretEntered()) {
            return true;
        } else {
            this.router.navigate(['dashboard']);
            return false;
        }
    }

}
